import React, {useState} from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { CardMedia, Grid, Hidden, Typography } from '@material-ui/core';
import { HeartButton, ShareButton } from 'modules3/components';
import EpisodeListButton from './components/EpisodeListButton';
import Controls from '../components/Controls';
import Popover from "@material-ui/core/Popover";
import { ShareButtons } from 'modules/player/components';
import radioImg from 'assets/images/podcast200x200.jpg';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'black',
    width: '100%',
    zIndex: 1100,
    position: 'fixed',
    bottom: 0,
    display: 'flex',
    left: 0,
    height: 100
  },
  mediaWrapper: {
    marginTop: -50,
    width: 140,
    height: 140,
    display: 'inline-block',
    border: '5px solid #C4C4C4',
    fontFamily: 'Arial',
    background: theme.palette.bodyColor,
    backgroundPosition: '0px -19px',
    backgroundSize: 203,
    backgroundPositionY: -19
  },
  cardImage: {
    width: 140,
    height: 140,
    objectFit: 'cover'
  },
  details: {
    color: '#fff',
    fontFamily: 'Arial',
    marginLeft: 10,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '50%'
  },
  title: {
    marginTop: 20,
    fontSize: 18,
    fontWeight: 'bold',
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  subtitle: {
    fontSize: 16,
    color: '#CECECE',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize'
  },
  heartAction: {
    display: 'block',
    width: '2.8rem'
    // marginTop: 20,
  },
  socialWrapper: {
    padding: 5
  }
}));

export default function Playbar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [socialShareMenuOpen, setSocialShareMenuOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const id2 = socialShareMenuOpen ? 'social-share-popover' : undefined;

  const style = {
    height: 30,
    width: 30,
    padding: '8px 0px',
    // marginRight: -15,
    fill: theme.palette.pink
  };

  const shareStyle = {
    height: 30,
    width: 30,
    padding: '8px 0px',
    fill: theme.palette.pink,
    [theme.breakpoints.up('sm')]: {
      marginTop: 14,
    }
  };

  const onMediaFallback = (event) => {
    event.target.src = radioImg;
  };

  const onFavouriteClickHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    props.onFavouriteClick();
  };

  const onShareClickHandler = (event) => {
    setSocialShareMenuOpen((prevState) => !prevState);
    setShareAnchorEl(event.currentTarget);
    event.stopPropagation();
    event.preventDefault();
    // props.onShareClickHandler(podcastid);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Hidden smDown>
          <Grid item md={3} lg={4}></Grid>
        </Hidden>
        <Grid item sm={6} md={4} lg={4}>
          <div style={{ display: 'flex' }}>
            <Hidden mdDown>
              <div className={classes.heartAction}>
                <EpisodeListButton />
              </div>
            </Hidden>
            <div className={classes.mediaWrapper}>
              <CardMedia
                alt="Image not available"
                component="img"
                className={classes.cardImage}
                src={props.image}
                onError={onMediaFallback}
              />
            </div>
            <div className={classes.details}>
              <Typography
                  className={classes.title}
                  component="span"
                  dangerouslySetInnerHTML={{ __html: props.title }}
              />
              <Typography className={classes.subtitle}>
                <span
                    className="line-clamp"
                    dangerouslySetInnerHTML={{ __html: props.subtitle }}
                />
              </Typography>
              <Typography className={classes.subtitle}>
                {props.audioStatus}
              </Typography>
              <Hidden lgUp>
                <div className={classes.heartAction}>
                  <EpisodeListButton />
                </div>
              </Hidden>
            </div>
          </div>
        </Grid>
        <Grid item sm={6} md={5} lg={4} style={{ display: 'flex' }}>
          <div className={classes.heartAction}>
            <HeartButton
              style={style}
              name={'Podcast'}
              isHearted={props.isHearted}
              onFavouriteClickHandler={onFavouriteClickHandler}
            />
            <ShareButton
              style={shareStyle}
              onShareClickHandler={onShareClickHandler}
            />
          </div>
          <Controls main {...props} />
        </Grid>
        <Popover
            id={id2}
            open={socialShareMenuOpen}
            anchorEl={shareAnchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            onClose={() => {
              setSocialShareMenuOpen(false);
              setShareAnchorEl(null);
            }}
        >
          <ShareButtons
              className={classes.socialWrapper}
              url={props.podcastLink}
              title={`Check out ${props.title}`}
              noPinterest
          />
        </Popover>
      </Grid>
    </div>
  );
}
